import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { VehiculoService } from '@app/core/services/vehiculo.service';
import { Aseguradora } from '@app/interfaces/gestion-vehicular/aseguradora.interface';
import { SeguroI } from '@app/interfaces/gestion-vehicular/seguro.interface';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-nueva-poliza',
  standalone: false,
  templateUrl: './nueva-poliza.component.html',
  styleUrl: './nueva-poliza.component.scss'
})
export class NuevaPolizaComponent {
  config = inject(DynamicDialogConfig);
  ref = inject(DynamicDialogRef);

  private readonly vehiculoService = inject(VehiculoService);

  form = new FormGroup({
    poliza: new FormControl('', [Validators.required]),
    fecha_vencimiento: new FormControl<Date | null>(null),
    adjunto: new FormControl<File | null>(null),
    vehiculos: new FormControl<string[]>([], { nonNullable: true })
  });

  vehiculos: { label: string; value: string }[] = [];

  // ! Arreglo para que muestre vehículos reales ==========
  ngOnInit() {
    this.vehiculoService.getAll().subscribe((data) => {
      this.vehiculos = data.entities
        .filter(v => v.dominio)
        .map(v => ({
          label: v.dominio!,
          value: v.id
        }));
    });
  }

  confirmar() {
    if (this.form.valid) {
      const { vehiculos, ...rest } = this.form.value;
      this.ref.close({
        ...rest,
        vehiculoIds: vehiculos,
        aseguradoraId: this.config.data?.aseguradoraId
      });
    } else {
      this.form.markAllAsTouched();
    }
  }

  onAdjuntoSelect(event: { files?: File[] }) {
    const file = event.files?.[0] ?? null;
    this.form.get('adjunto')?.setValue(file);
  }

  onAdjuntoClear() {
    this.form.get('adjunto')?.setValue(null);
  }

  cancelar() {
    this.ref.close();
  }

}
